/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StockMarketOrderMobile { 
    id?: number;
    generalOrderId?: number;
    accountId?: string;
    orderDate?: string;
    executionDate: string;
    quantity?: number;
    orderPrice?: number;
    exchangeRate?: number;
    gross?: number;
    grossCurrencyId?: string;
    net?: number;
    netCurrencyId?: string;
    securityId?: number;
    limitDate?: string;
    instructionTypeValue?: StockMarketOrderMobile.InstructionTypeValueEnum;
    limitTypeValue?: StockMarketOrderMobile.LimitTypeValueEnum;
    limitPrice?: number;
    orderSide?: StockMarketOrderMobile.OrderSideEnum;
    orderStatus?: StockMarketOrderMobile.OrderStatusEnum;
    apiOrderCreationStatus?: StockMarketOrderMobile.ApiOrderCreationStatusEnum;
    apiOrderStatus?: StockMarketOrderMobile.ApiOrderStatusEnum;
    identification?: string;
}
export namespace StockMarketOrderMobile {
    export const InstructionTypeValueEnum = {
        ORDER_AT_BEST: 'ORDER_AT_BEST',
        LIMIT_ORDER: 'LIMIT_ORDER',
        AT_OPENING: 'AT_OPENING',
        DISCRETIONARY: 'DISCRETIONARY',
        SUBSCRIPTION: 'SUBSCRIPTION',
        STOP: 'STOP',
        TRAIL: 'TRAIL',
        FUND: 'FUND',
        DIRECT: 'DIRECT',
        CONFIRMATION: 'CONFIRMATION',
        GOOD_TIL_CANCELLED: 'GOOD_TIL_CANCELLED',
        MARKET_ON_CLOSE: 'MARKET_ON_CLOSE',
        VOLUME_WEIGHTED_AVERAGE_PRICE: 'VOLUME_WEIGHTED_AVERAGE_PRICE',
        TIME_WEIGHTED_AVERAGE_PRICE: 'TIME_WEIGHTED_AVERAGE_PRICE',
        STRICT_LIMIT: 'STRICT_LIMIT'
    } as const;
    export type InstructionTypeValueEnum = typeof InstructionTypeValueEnum[keyof typeof InstructionTypeValueEnum];
    export const LimitTypeValueEnum = {
        GOOD_DAY_ONLY: 'GOOD_DAY_ONLY',
        GOOD_TILL_CANCEL: 'GOOD_TILL_CANCEL',
        GOOD_TILL_DATE: 'GOOD_TILL_DATE',
        AT_THE_OPENING: 'AT_THE_OPENING',
        AT_THE_CLOSE: 'AT_THE_CLOSE'
    } as const;
    export type LimitTypeValueEnum = typeof LimitTypeValueEnum[keyof typeof LimitTypeValueEnum];
    export const OrderSideEnum = {
        BUY: 'BUY',
        SELL: 'SELL'
    } as const;
    export type OrderSideEnum = typeof OrderSideEnum[keyof typeof OrderSideEnum];
    export const OrderStatusEnum = {
        ORDER_BOOK: 'ORDER_BOOK',
        PENDING: 'PENDING',
        VALIDATE: 'VALIDATE',
        WAITING_VALIDATION: 'WAITING_VALIDATION',
        DELETED: 'DELETED',
        PROVISIONAL_ACCOUNTING: 'PROVISIONAL_ACCOUNTING',
        PENDING_TO_CONFIRM: 'PENDING_TO_CONFIRM',
        ADVISORY: 'ADVISORY',
        WAITING_ADVISORY: 'WAITING_ADVISORY',
        REFUSED_ADVISORY: 'REFUSED_ADVISORY',
        LIMIT_EXPIRED: 'LIMIT_EXPIRED',
        EXECUTED: 'EXECUTED',
        WAITING_EXECUTION: 'WAITING_EXECUTION',
        TRADING_ACKNOWLEDGED: 'TRADING_ACKNOWLEDGED',
        TRADING_REJECTED: 'TRADING_REJECTED'
    } as const;
    export type OrderStatusEnum = typeof OrderStatusEnum[keyof typeof OrderStatusEnum];
    export const ApiOrderCreationStatusEnum = {
        PENDING_AUTHORIZATION: 'PENDING_AUTHORIZATION',
        WAITING_AUTHORIZATION_CONFIRMATION: 'WAITING_AUTHORIZATION_CONFIRMATION',
        AUTHORIZATION_SUCCEEDED: 'AUTHORIZATION_SUCCEEDED',
        AUTHORIZATION_FAILED: 'AUTHORIZATION_FAILED',
        AUTHORIZATION_EXPIRED: 'AUTHORIZATION_EXPIRED'
    } as const;
    export type ApiOrderCreationStatusEnum = typeof ApiOrderCreationStatusEnum[keyof typeof ApiOrderCreationStatusEnum];
    export const ApiOrderStatusEnum = {
        DRAFT: 'DRAFT',
        PENDING: 'PENDING',
        DECLINED: 'DECLINED',
        APPROVED: 'APPROVED',
        EXECUTED: 'EXECUTED',
        ACCOUNTED: 'ACCOUNTED',
        FAILED: 'FAILED',
        EXPIRED: 'EXPIRED'
    } as const;
    export type ApiOrderStatusEnum = typeof ApiOrderStatusEnum[keyof typeof ApiOrderStatusEnum];
}


